import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DatePicker, Dropdown } from "components";
import { useRegisterNavAction } from "hooks";
import "modules/ExactMonitoring/components/Billing/Billing.scss";
import { BillingTable } from "modules/ExactMonitoring/components/Billing/components";
import {
  setInvoicedDealersAndLocationsFilters,
  useInvoicedDealersAndLocationsFilters,
  useInvoicedDealersAndLocationsQuery
} from "modules/ExactMonitoring/components/Billing/hooks";

enum INVOICE_STATUS {
  Fail = 0,
  Success
}

const MAX_RANGE_DAYS = 31;

export const Billing = () => {
  const { t } = useTranslation();

  const filters = useInvoicedDealersAndLocationsFilters();
  const {
    data: invoicedDealersAndLocations,
    isRefetching: isInvoicedDealersAndLocationsRefetching,
    isFetching: isInvoicedDealersAndLocationsFetching,
    refetch: refetchInvoicedDealersAndLocations
  } = useInvoicedDealersAndLocationsQuery(filters);

  useRegisterNavAction(refetchInvoicedDealersAndLocations);

  const handleFailedChange = (failed: boolean) => setInvoicedDealersAndLocationsFilters({ ...filters, failed });
  const handleDateChange = (...dates: (Date | null)[]) => {
    const [start, end] = dates;
    setInvoicedDealersAndLocationsFilters({ ...filters, date_from: start, date_to: end });
  };

  return (
    <div className="Billing">
      <div className="filters-container">
        <Grid columns={16}>
          <Grid.Row>
            <Grid.Column width={8}>
              <Dropdown
                fluid
                selection
                options={[
                  { key: INVOICE_STATUS.Fail, value: INVOICE_STATUS.Fail, text: t("v8_show_failed", "Show Failed") },
                  { key: INVOICE_STATUS.Success, value: INVOICE_STATUS.Success, text: t("v8_show_succeeded", "Show Succeeded") }
                ]}
                selectOnBlur={false}
                onChange={invoiceStatus => handleFailedChange(invoiceStatus === INVOICE_STATUS.Fail ? true : false)}
                value={filters.failed ? INVOICE_STATUS.Fail : INVOICE_STATUS.Success}
              />
            </Grid.Column>

            <Grid.Column width={8}>
              <DatePicker
                startDate={filters.date_from}
                endDate={filters.date_to}
                onDateChange={handleDateChange}
                selectsRange
                showLabel
                clearable
                fluid
                maxRangeDays={MAX_RANGE_DAYS}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      <BillingTable
        invoicedDealersAndLocations={invoicedDealersAndLocations}
        isLoading={isInvoicedDealersAndLocationsFetching || isInvoicedDealersAndLocationsRefetching}
      />
    </div>
  );
};
